import { pathOr } from 'ramda';
import { queries } from '../../graphql';
import { IGetCodes } from '../interfaces/IQueryEvents';

export const getCodes = (props: IGetCodes): void => {
  const { defaultPromoId } = props;
  const { client, setCodesToReducer } = props;

  client
    .query({
      query: queries.GET_CODES,
      variables: {
        id: defaultPromoId
      }
    })
    .then((item: any) => {
      const data: object = {
        codes: pathOr(
          [],
          ['data', 'promocodes', 'getById', 'codes', 'list'],
          item
        )
      };
      setCodesToReducer(data);
    });
};
